import React from 'react';
import { Box, Typography } from '@mui/material';
import { PageHeader } from '@NP-Webber/crm-kit/dist/next/index.js';
import EmailDomainSettings from '../../components/emailDomain/EmailDomainSettings';

const SUB = 'כתובת השולח של הארגון, רשומות DNS ואימות הדומיין';

/** דומיין לשליחת מיילים — new design (the wizard brings its own panels) */
export function EmailDomainPageNext() {
  return (
    <div className="nx-stack nx-narrow">
      <PageHeader title="דומיין לשליחת מיילים" sub={SUB} />
      <EmailDomainSettings />
    </div>
  );
}

/** דומיין לשליחת מיילים — old design; the wizard is crm-kit next and brings its own theme root */
export default function EmailDomainPage() {
  return (
    <Box sx={{ maxWidth: 960 }}>
      <Typography variant="h5" fontWeight={700} gutterBottom>דומיין לשליחת מיילים</Typography>
      <Typography color="text.secondary" sx={{ mb: 2 }}>{SUB}</Typography>
      <EmailDomainSettings />
    </Box>
  );
}
